import "./matchClockCounter.sass";
import { useMatchClock } from "../../../../../hooks/useMatchClock";

/**
 * Componente que muestra el reloj del partido en tiempo real
 * Se actualiza cada segundo cuando el partido está en vivo
 * 
 * Comportamiento:
 * - Si NO hay period_start: mostrar solo periodTitle (desde props)
 * - Si es pausa (10-13) sin period_start: mostrar solo periodTitle (desde props)
 * - Si hay period_start y server_time: mostrar reloj + injuryTime
 * 
 * Props:
 * - soccerData: Objeto con period_id, period_start, announced_injury_time
 * - periodTitle: Título del periodo (viene desde matchInformation via matchTimeline)
 * - className: Clases CSS adicionales (opcional)
 */
export default function MatchClockCounter({ soccerData, periodTitle, className = "", clase }) {
  const { clock, injuryTime, isActive } = useMatchClock(soccerData);

  if (clase !== "clarosports-finished-game" && clase !== "clarosports-in-progress-game") {
    return
  }

  return (
    <div className={`match-clock-counter ${className}`}>
      {(isActive && clock) &&
        <div className="clock-display">
          <span className="clock-time">{clock}</span>
          {injuryTime && <span className="injury-time">{injuryTime}</span>}
        </div>
      }
      {periodTitle && (
        <div className="clock-period">
          <span className="period-title">{periodTitle}</span>
        </div>
      )}
    </div>
  );
}